import {
  SUBJECT_ADMIN,
  SUBJECT_OWNER_USER,
  SUBJECT_USER,
} from "models/role/subject";

import type { PermissionsAll } from "modules/auth/constants/permissions";
import type { Customer } from "modules/customers/models/Customer";
import type { UUID } from "utils";
import type { ObjectWithId } from "utils/ObjectWithId";

export interface UserMetadata {
  termsAcceptanceDate?: string;
}

export interface User extends ObjectWithId {
  active: boolean;
  email: string;
  lastSuccessfulLogin: string | null;
  locked: boolean;
  name: string;
  owner: boolean;
  permissions: PermissionsAll[];
  scaAuthentication: UserScaAuthentication;
  voltEmployee: boolean;
  customer?: CurrentCustomer;
}

export interface UserScaAuthentication {
  active: boolean;
  subjectId: UUID | null;
}

export interface CurrentCustomer
  extends Pick<Customer, "active" | "discr" | "id" | "name"> {
  integratorCustomer: Pick<Customer, "id" | "name"> | null;
  parentCustomer: Pick<Customer, "id" | "name"> | null;
}

export interface CurrentUser extends User {
  lastSuccessfulLogin: string | null;
  metadata: UserMetadata;
}

export type BasicUser = ObjectWithId & {
  customerId: UUID;
  name: string;
};

export const PROPERTY_ACTIVE = "active";

export function getSubjectFromUser(user?: Partial<User>) {
  if (user?.voltEmployee) {
    return SUBJECT_ADMIN;
  }

  if (user?.owner) {
    return SUBJECT_OWNER_USER;
  }

  return SUBJECT_USER;
}

export type UserNames = Record<UUID, string | undefined>;
